import { useLocalStorage } from "@mantine/hooks";
import { useMemo } from "react";

import { SavedEvent } from "event/types/event.model";

export function useSavedEvent(eventId: string) {
  const [savedEvents, setSavedEvents] = useLocalStorage<
    Record<string, SavedEvent>
  >({
    key: "events",
    getInitialValueInEffect: false,
  });

  return useMemo(
    () =>
      [
        (savedEvents || {})[eventId],
        (savedEvent: SavedEvent) =>
          setSavedEvents((events) => {
            return {
              ...events,
              [eventId]: savedEvent,
            };
          }),
      ] as const,
    [savedEvents, setSavedEvents, eventId],
  );
}
